(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["silver-bar-multi-step"] && !Shopify.designMode) return;
  try {
    
    class SilverBarMultiStep {
      constructor() {
        this.root = document.querySelector('.sbms');
        if (!this.root) return;

        this.currentStep = 1;
        this.selectedQuantity = null; // Will be set based on selected plan
        this.selectedDesign = null;
        this.selectedPlan = 'monthly';
        this.selectedPriceLock = true; // Default to yes
        this.selectedPaymentPlan = 'monthly'; // Default payment plan
        this.selectedPlanElement = null; // Store reference to selected plan element

        this.init();
      }

      init() {
        this.bindEvents();
        this.setDefaultSelectedPlan();
        this.preselectFirstDesign();
        this.updatePricing();
        this.updatePriceLockPricing();
        this.updateStep4Pricing();
        this.showStep(1);
        this.scrollToSelectedPlan();
      }

      bindEvents() {
        // Plan selection
        this.root.querySelectorAll('[data-plan]').forEach(plan => {
          plan.addEventListener('click', () => this.selectPlan(plan));
        });

        // Design selection
        this.root.querySelectorAll('[data-design]').forEach(design => {
          design.addEventListener('click', () => this.selectDesign(design));
        });

        // Price lock selection - use specific class selector to avoid plan cards
        this.root.querySelectorAll('.sbms__price-lock-option').forEach(option => {
          option.addEventListener('click', () => this.selectPriceLock(option));
        });

        // Payment plan selection
        this.root.querySelectorAll('[data-payment-plan]').forEach(plan => {
          plan.addEventListener('click', () => this.selectPaymentPlan(plan));
        });

        // Navigation buttons
        this.root.querySelectorAll('[data-next-step]').forEach(btn => {
          btn.addEventListener('click', () => this.nextStep());
        });

        this.root.querySelectorAll('[data-prev-step]').forEach(btn => {
          btn.addEventListener('click', () => this.prevStep());
        });

        // Continue button
        const continueBtn = this.root.querySelector('#sbms-continue');
        if (continueBtn) {
          continueBtn.addEventListener('click', (e) => this.handleContinue(e));
        }

        // Checkout button
        const checkoutBtn = this.root.querySelector('#sbms-checkout');
        if (checkoutBtn) {
          checkoutBtn.addEventListener('click', (e) => this.handleCheckout(e));
        }

        // Compare button
        const compareButton = this.root.querySelector('.sbms__compare-toggle');
        if (compareButton) {
          compareButton.addEventListener('click', (e) => {
            e.preventDefault();
            const compareModal = document.querySelector('compare-modal');
            if (compareModal && compareModal.open) {
              compareModal.open();
            }
          });
        }

        // Price lock info button
        const priceLockInfoButton = this.root.querySelector('.sbms__price-lock-info-toggle');
        if (priceLockInfoButton) {
          priceLockInfoButton.addEventListener('click', (e) => {
            e.preventDefault();
            const priceLockInfoModal = document.querySelector('price-lock-info-modal');
            if (priceLockInfoModal && priceLockInfoModal.open) {
              priceLockInfoModal.open();
            }
          });
        }
      }

      selectPlan(plan) {
        // Remove previous selection
        this.root.querySelectorAll('[data-plan]').forEach(p => p.classList.remove('sbms__plan--selected'));

        // Select new plan
        plan.classList.add('sbms__plan--selected');
        this.selectedQuantity = parseInt(plan.dataset.quantity);

        // Store the selected plan for later use
        this.selectedPlanElement = plan;


        // Update pricing with tax calculation
        this.updatePricing();

        // Update step 3 price lock pricing
        this.updatePriceLockPricing();

        // Update step 4 payment plan pricing
        this.updateStep4Pricing();

        // Update design images if a design is already selected
        if (this.selectedDesign) {
          this.updateDesignImages(this.selectedDesign);
        }
      }

      selectDesign(design) {
        // Remove previous selection
        this.root.querySelectorAll('[data-design]').forEach(d => d.classList.remove('sbms__design--selected'));

        // Select new design
        design.classList.add('sbms__design--selected');
        this.selectedDesign = design;

        // Update selection title and description
        const selectionTitle = this.root.querySelector('[data-selection-title]');
        const selectionDescription = this.root.querySelector('[data-selection-description]');

        if (selectionTitle) {
          const designTitle = design.dataset.title || 'Design selected';
          selectionTitle.textContent = designTitle;
        }

        if (selectionDescription) {
          const designDescription = design.dataset.description || '';
          selectionDescription.textContent = designDescription;
        }

        // Update product images in steps 2 and 4 to show the selected design's image
        this.updateDesignImages(design);

        // Update pricing for the selected design
        this.updatePricing();

        // Update step 4 payment plan pricing
        this.updateStep4Pricing();
      }

      updateDesignImages(design) {
        // Get the product image based on selected quantity and design
        const productImageSrc = this.getProductImageForDesign(design);
        if (!productImageSrc) return;

        // Update images in step 2 (simple image)
        const step2Image = this.root.querySelector('[data-step="2"] .sbms__step-image');
        if (step2Image) {
          step2Image.src = productImageSrc;
          step2Image.alt = design.dataset.title || 'Selected design';
        }

        // Update images in step 4 (simple image)
        const step4Image = this.root.querySelector('[data-step="4"] .sbms__step-image');
        if (step4Image) {
          step4Image.src = productImageSrc;
          step4Image.alt = design.dataset.title || 'Selected design';
        }
      }

      getProductImageForDesign(design) {
        // Get the bar image from the design
        let barImageSrc = design.dataset.barImage;

        if (!barImageSrc) {
          barImageSrc = design.getAttribute('data-bar-image');
        }

        // Fix the URL if it's missing the protocol
        if (barImageSrc && barImageSrc.startsWith('//')) {
          barImageSrc = 'https:' + barImageSrc;
        }
        return barImageSrc;
      }

      preselectFirstDesign() {
        // Find the first design and preselect it (without triggering pricing updates)
        const firstDesign = this.root.querySelector('[data-design]');
        if (firstDesign) {
          // Remove previous selection
          this.root.querySelectorAll('[data-design]').forEach(d => d.classList.remove('sbms__design--selected'));

          // Select new design
          firstDesign.classList.add('sbms__design--selected');
          this.selectedDesign = firstDesign;

          // Update selection title and description
          const selectionTitle = this.root.querySelector('[data-selection-title]');
          const selectionDescription = this.root.querySelector('[data-selection-description]');

          if (selectionTitle) {
            const designTitle = firstDesign.dataset.title || 'Design selected';
            selectionTitle.textContent = designTitle;
          }

          if (selectionDescription) {
            const designDescription = firstDesign.dataset.description || '';
            selectionDescription.textContent = designDescription;
          }

          // Update product images
          this.updateDesignImages(firstDesign);

          // Note: Not calling updatePricing() here to avoid double pricing update during init
        }
      }

      selectPriceLock(option) {
        // Remove previous selection - use more specific selector to avoid affecting plan cards
        this.root.querySelectorAll('.sbms__price-lock-option').forEach(o => o.classList.remove('sbms__price-lock-option--selected'));

        // Select new option
        option.classList.add('sbms__price-lock-option--selected');
        this.selectedPriceLock = option.dataset.priceLock === 'yes';
      }

      // Helper method to ensure visual state matches JavaScript state
      syncPriceLockVisualState() {
        const priceLockYes = this.root.querySelector('.sbms__price-lock-option[data-price-lock="yes"]');
        const priceLockNo = this.root.querySelector('.sbms__price-lock-option[data-price-lock="no"]');

        if (priceLockYes && priceLockNo) {
          // Remove selected class from both
          priceLockYes.classList.remove('sbms__price-lock-option--selected');
          priceLockNo.classList.remove('sbms__price-lock-option--selected');

          // Add selected class to the correct option based on JavaScript state
          if (this.selectedPriceLock) {
            priceLockYes.classList.add('sbms__price-lock-option--selected');
          } else {
            priceLockNo.classList.add('sbms__price-lock-option--selected');
          }
        }
      }

      selectPaymentPlan(plan) {
        // Remove previous selection
        this.root.querySelectorAll('[data-payment-plan]').forEach(p => p.classList.remove('sbms__payment-plan--selected'));

        // Select new plan
        plan.classList.add('sbms__payment-plan--selected');
        this.selectedPaymentPlan = plan.dataset.paymentPlan;
      }

      async updatePricing() {
        // Update pricing display based on selected quantity and design
        const priceDisplays = this.root.querySelectorAll('[data-pricing-display]');
        if (!priceDisplays.length || !this.selectedQuantity) {
          return;
        }

        // Get current design to determine which product to use
        let currentDesign = this.selectedDesign;
        if (!currentDesign) {
          // If no design selected yet, use the first design
          currentDesign = this.root.querySelector('[data-design]');
        }

        if (!currentDesign) {
          return;
        }

        // Get the variant ID for the selected quantity
        const variantId = currentDesign.getAttribute(`data-variant-${this.selectedQuantity}`);
        if (!variantId) {
          return;
        }

        try {
          // Fetch variant data from Shopify
          const response = await fetch(`/variants/${variantId}.js`);
          if (!response.ok) return;

          const variantData = await response.json();

          // Check if tax adjustment is needed for this market
          const shouldAdjustTax = this.root.dataset.shouldAdjustTax === 'true';
          const shopTaxesIncluded = this.root.dataset.shopTaxesIncluded === 'true';

          let priceBeforeTax, compareBeforeTax;

          // Check if we should adjust based on both server-side logic AND variant taxable property
          const variantIsTaxable = variantData.taxable === true;
          const needsTaxAdjustment = shouldAdjustTax && variantIsTaxable;

          if (needsTaxAdjustment) {
            // Get tax rate from section settings
            const taxRate = parseFloat(this.root.dataset.taxRate || 20); // Default to 20%
            const taxMultiplier = 1 + (taxRate / 100);

            // Calculate price before tax from Shopify's tax-inclusive price
            priceBeforeTax = Math.round(variantData.price / taxMultiplier);
            compareBeforeTax = variantData.compare_at_price ? Math.round(variantData.compare_at_price / taxMultiplier) : null;

          } else {
            // Use the original price (either tax-exclusive market or non-taxable variant)
            priceBeforeTax = variantData.price;
            compareBeforeTax = variantData.compare_at_price || null;
          }

          // Use Shopify's money formatting by creating a temporary element
          // This preserves the exact currency formatting from the current market
          const formattedPrice = this.formatPriceUsingShopify(priceBeforeTax);
          const formattedComparePrice = compareBeforeTax ? this.formatPriceUsingShopify(compareBeforeTax) : null;

          // Update price elements in all pricing displays
          priceDisplays.forEach(priceDisplay => {
            // Make pricing visible once we have calculated prices
            priceDisplay.style.visibility = 'visible';

            const priceNew = priceDisplay.querySelector('.sbms__price-new');
            const priceOld = priceDisplay.querySelector('.sbms__price-old');
            const priceBadge = priceDisplay.querySelector('.sbms__price-badge');

            if (priceNew) {
              priceNew.textContent = formattedPrice + (needsTaxAdjustment ? '*' : '');
            }

            if (priceOld && formattedComparePrice) {
              priceOld.textContent = formattedComparePrice + (needsTaxAdjustment ? '*' : '');
              priceOld.style.display = 'inline';

              // Calculate savings percentage
              const savingsAmount = compareBeforeTax - priceBeforeTax;
              const savingsPercentage = Math.round((savingsAmount / compareBeforeTax) * 100);

              if (priceBadge && savingsPercentage > 0) {
                priceBadge.textContent = `Save ${savingsPercentage}%`;
                priceBadge.style.display = 'inline';
              }
            } else {
              if (priceOld) priceOld.style.display = 'none';
              if (priceBadge) priceBadge.style.display = 'none';
            }
          });

        } catch (error) {
          // Silently handle pricing fetch errors
        }
      }

      formatPriceUsingShopify(priceInCents) {
        // Use Shopify's theme currency settings for proper localization
        const amount = priceInCents / 100;



        // Try to use Shopify's theme.formatMoney if available
        if (typeof theme !== 'undefined' && theme.formatMoney) {
          return theme.formatMoney(priceInCents);
        }

        // Try to use Shopify's Currency if available
        if (typeof Currency !== 'undefined' && Currency.formatMoney) {
          return Currency.formatMoney(priceInCents);
        }

        // Use browser's Intl.NumberFormat with Shopify's currency from section data
        const currencyCode = this.root.dataset.currentCurrency ||
                            document.documentElement.getAttribute('data-currency') ||
                            'GBP'; // fallback

        try {
          const formatter = new Intl.NumberFormat('en', {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            currencyDisplay: 'symbol'
          });
          let formattedPrice = formatter.format(amount);

          // Generic cleanup: remove country prefixes from currency symbols
          // This handles CA$, A$, US$, NZ$, etc. automatically
          formattedPrice = formattedPrice.replace(/^[A-Z]{2}\$/, '$');

          return formattedPrice;
        } catch (error) {
          // Final fallback: simple format with currency symbol
          const getGenericCurrencySymbol = (code) => {
            const commonSymbols = {
              'GBP': '£',
              'EUR': '€',
              'JPY': '¥',
              'KRW': '₩',
              'INR': '₹'
            };

            // For any currency ending in 'D' (like USD, CAD, AUD, NZD), use $
            if (code.endsWith('D') && code.length === 3) {
              return '$';
            }

            return commonSymbols[code] || code;
          };

          const symbol = getGenericCurrencySymbol(currencyCode);
          return `${symbol}${amount.toFixed(2)}`;
        }
      }

      async updatePriceLockPricing() {
        // Update the price lock pricing in step 3 subtitle based on selected plan
        if (!this.selectedPlanElement) return;

        const priceLockVariantId = this.selectedPlanElement.getAttribute('data-price-lock');
        if (!priceLockVariantId) return;

        try {
          // Fetch variant data from Shopify
          const response = await fetch(`/variants/${priceLockVariantId}.js`);
          if (!response.ok) return;

          const variantData = await response.json();

          // For step 3 price lock, always use the standard Shopify price (no tax adjustment)
          const priceLockDisplayPrice = this.formatPriceUsingShopify(variantData.price);

          // Update step 3 subtitle with the new price
          const step3Subtitle = this.root.querySelector('[data-step="3"] .sbms__step-subtitle[data-original-template]');
          if (step3Subtitle && priceLockDisplayPrice) {
            // Use the server-provided template and replace the placeholder with the actual price
            const template = step3Subtitle.dataset.originalTemplate;
            const updatedText = template.replace('__PRICE__', priceLockDisplayPrice);
            step3Subtitle.textContent = updatedText;
          }

        } catch (error) {
          // Silently handle price lock pricing fetch errors
        }
      }

      async updateStep4Pricing() {
        // Update Step 4 payment plan pricing based on selected quantity and design
        if (!this.selectedQuantity || !this.selectedDesign) {
          return;
        }

        // Get the selling plan pricing data from the design element
        const monthlyPlanPrice = this.selectedDesign.getAttribute(`data-month-plan-${this.selectedQuantity}-price`);
        const annualPlanPrice = this.selectedDesign.getAttribute(`data-annual-plan-${this.selectedQuantity}-price`);



        // Check if we have selling plan pricing data available
        if (!monthlyPlanPrice && !annualPlanPrice) {


          // Fallback to the original calculation method
          return this.updateStep4PricingFallback();
        }

        // Check if tax adjustment is needed
        const shouldAdjustTax = this.root.dataset.shouldAdjustTax === 'true';
        const needsTaxAdjustment = shouldAdjustTax;

        let monthlyPrice, annualPrice;

        if (needsTaxAdjustment) {
          // Calculate tax-adjusted prices from selling plan data
          const taxRate = parseFloat(this.root.dataset.taxRate || 20);
          const taxMultiplier = 1 + (taxRate / 100);

          monthlyPrice = monthlyPlanPrice ? Math.round(parseInt(monthlyPlanPrice) / taxMultiplier) : null;
          annualPrice = annualPlanPrice ? Math.round(parseInt(annualPlanPrice) / taxMultiplier) : null;
        } else {
          // Use selling plan prices directly
          monthlyPrice = monthlyPlanPrice ? parseInt(monthlyPlanPrice) : null;
          annualPrice = annualPlanPrice ? parseInt(annualPlanPrice) : null;
        }

        // Update monthly pricing
        if (monthlyPrice) {
          const monthlyPriceElement = this.root.querySelector('[data-payment-price="monthly"]');
          if (monthlyPriceElement) {
            const formattedMonthlyPrice = this.formatPriceUsingShopify(monthlyPrice);
            monthlyPriceElement.textContent = formattedMonthlyPrice + (needsTaxAdjustment ? '*' : '');
          }
        }

        // Update annual pricing (if we have annual selling plan data)
        if (annualPrice) {
          const annualPriceElement = this.root.querySelector('[data-payment-price="annual"]');
          const annualTotalElement = this.root.querySelector('[data-payment-price-total="annual"]');

          // The annualPrice from selling plan is the TOTAL annual cost, not monthly
          // So we need to divide by 12 to get the monthly equivalent for display
          const annualMonthlyPrice = Math.round(annualPrice / 12);
          const annualTotalPrice = annualPrice; // This is already the total

          if (annualPriceElement) {
            const formattedAnnualPrice = this.formatPriceUsingShopify(annualMonthlyPrice);
            annualPriceElement.textContent = formattedAnnualPrice + (needsTaxAdjustment ? '*' : '');
          }

          if (annualTotalElement) {
            const formattedAnnualTotal = this.formatPriceUsingShopify(annualTotalPrice);
            annualTotalElement.textContent = formattedAnnualTotal + (needsTaxAdjustment ? '*' : '');
          }

          // Update savings text (if we have both monthly and annual prices)
          if (monthlyPrice) {
            const savingsElement = this.root.querySelector('[data-savings-text]');
            if (savingsElement) {
              const monthlyTotal = monthlyPrice * 12;
              const yearlySavings = monthlyTotal - annualTotalPrice;
              const formattedSavings = this.formatPriceUsingShopify(yearlySavings);
              savingsElement.textContent = `Save an extra ${formattedSavings}${needsTaxAdjustment ? '*' : ''} a year`;
            }
          }



        }
      }

      async updateStep4PricingFallback() {
        // Fallback method using the original calculation approach
        const monthlyVariantId = this.selectedDesign.getAttribute(`data-variant-${this.selectedQuantity}`);

        if (!monthlyVariantId) {
          return;
        }

        try {
          // Fetch the base variant data
          const response = await fetch(`/variants/${monthlyVariantId}.js`);
          if (!response.ok) return;

          const variantData = await response.json();

          // Check if tax adjustment is needed
          const shouldAdjustTax = this.root.dataset.shouldAdjustTax === 'true';
          const variantIsTaxable = variantData.taxable === true;
          const needsTaxAdjustment = shouldAdjustTax && variantIsTaxable;

          let basePrice;

          if (needsTaxAdjustment) {
            // Calculate tax-adjusted price
            const taxRate = parseFloat(this.root.dataset.taxRate || 20);
            const taxMultiplier = 1 + (taxRate / 100);
            basePrice = Math.round(variantData.price / taxMultiplier);
          } else {
            basePrice = variantData.price;
          }

          // Update monthly pricing
          const monthlyPriceElement = this.root.querySelector('[data-payment-price="monthly"]');
          if (monthlyPriceElement) {
            const formattedMonthlyPrice = this.formatPriceUsingShopify(basePrice);
            monthlyPriceElement.textContent = formattedMonthlyPrice + (needsTaxAdjustment ? '*' : '');
          }

          // Calculate annual pricing based on section settings
          const annualDiscountRate = parseFloat(this.root.dataset.annualDiscountRate || 10) / 100;
          const annualMonthlyPrice = Math.round(basePrice * (1 - annualDiscountRate));
          const annualTotalPrice = annualMonthlyPrice * 12;

          // Update annual pricing
          const annualPriceElement = this.root.querySelector('[data-payment-price="annual"]');
          const annualTotalElement = this.root.querySelector('[data-payment-price-total="annual"]');

          if (annualPriceElement) {
            const formattedAnnualPrice = this.formatPriceUsingShopify(annualMonthlyPrice);
            annualPriceElement.textContent = formattedAnnualPrice + (needsTaxAdjustment ? '*' : '');
          }

          if (annualTotalElement) {
            const formattedAnnualTotal = this.formatPriceUsingShopify(annualTotalPrice);
            annualTotalElement.textContent = formattedAnnualTotal + (needsTaxAdjustment ? '*' : '');
          }

          // Update savings text
          const savingsElement = this.root.querySelector('[data-savings-text]');
          if (savingsElement) {
            const monthlyTotal = basePrice * 12;
            const yearlySavings = monthlyTotal - annualTotalPrice;
            const formattedSavings = this.formatPriceUsingShopify(yearlySavings);
            savingsElement.textContent = `Save an extra ${formattedSavings}${needsTaxAdjustment ? '*' : ''} a year`;
          }




        } catch (error) {
          // Silently handle Step 4 pricing fetch errors
        }
      }


      updatePricingDisplay(planElement = null) {
        const priceDisplays = this.root.querySelectorAll('[data-pricing-display]');
        if (!priceDisplays.length) return;

        // Use the provided plan element or find the currently selected one
        const selectedPlan = planElement || this.root.querySelector('.sbms__plan--selected');
        if (!selectedPlan) return;

        // Get pricing data from the plan's data attributes
        const price = selectedPlan.getAttribute('data-price');
        const comparePrice = selectedPlan.getAttribute('data-compare-price');

        // Update price elements in all pricing displays
        priceDisplays.forEach(priceDisplay => {
          // Make pricing visible once we have calculated prices
          priceDisplay.style.visibility = 'visible';

          const priceNew = priceDisplay.querySelector('.sbms__price-new');
          const priceOld = priceDisplay.querySelector('.sbms__price-old');
          const priceBadge = priceDisplay.querySelector('.sbms__price-badge');

          if (priceNew && price) {
            priceNew.textContent = price;
          }

          // Show/hide old price
          if (priceOld) {
            if (comparePrice && comparePrice !== price) {
              priceOld.textContent = comparePrice;
              priceOld.style.display = 'inline-block';
            } else {
              priceOld.style.display = 'none';
            }
          }

          // Calculate and show savings badge
          if (priceBadge) {
            if (comparePrice && price && comparePrice.trim() !== '' && price.trim() !== '') {
              // Extract numeric values for calculation
              const priceNumeric = parseFloat(price.replace(/[^\d.]/g, ''));
              const comparePriceNumeric = parseFloat(comparePrice.replace(/[^\d.]/g, ''));

              // Check if we have valid numbers and compare price is higher
              if (!isNaN(priceNumeric) && !isNaN(comparePriceNumeric) && comparePriceNumeric > priceNumeric && comparePriceNumeric > 0) {
                const savings = Math.round(((comparePriceNumeric - priceNumeric) / comparePriceNumeric) * 100);
                if (savings > 0) {
                  priceBadge.textContent = `Save ${savings}%`;
                  priceBadge.style.display = 'inline-block';
                } else {
                  priceBadge.style.display = 'none';
                }
              } else {
                priceBadge.style.display = 'none';
              }
            } else {
              // Hide badge if no valid pricing data
              priceBadge.style.display = 'none';
            }
          }
        });
      }

      showStep(step) {
        this.currentStep = step;

        // Hide all steps
        this.root.querySelectorAll('[data-step]').forEach(s => {
          s.classList.remove('sbms__step--active');
        });

        // Show current step
        const currentStepEl = this.root.querySelector(`[data-step="${step}"]`);
        if (currentStepEl) {
          currentStepEl.classList.add('sbms__step--active');
        }

        // Update step-specific content when showing step 3
        if (step === 3) {
          this.updatePriceLockPricing();
        }

        // Update step-specific content when showing step 4
        if (step === 4) {
          this.updateStep4Pricing();
        }

        // Update step indicators if you have them
        this.updateStepIndicators();
      }

      nextStep() {
        if (this.currentStep < 4) {
          this.showStep(this.currentStep + 1);
        }
      }

      prevStep() {
        if (this.currentStep > 1) {
          this.showStep(this.currentStep - 1);
        }
      }

      updateStepIndicators() {
        // Update any step indicators or progress bars
        // This would be implemented based on your design needs
      }

      setDefaultSelectedPlan() {
        // Find the default selected plan (either popular pick or first plan)
        const selectedPlan = this.root.querySelector('.sbms__plan--selected');
        if (selectedPlan) {
          this.selectedPlanElement = selectedPlan;
          // Set the selected quantity from the selected plan
          this.selectedQuantity = parseInt(selectedPlan.dataset.quantity);
        }
      }

      scrollToSelectedPlan() {
        // Only scroll on mobile
        if (window.innerWidth > 768) return;

        const plansContainer = this.root.querySelector('.sbms__plans');
        const selectedPlan = this.root.querySelector('.sbms__plan--selected');

        if (!plansContainer || !selectedPlan) return;

        // Use setTimeout to ensure DOM is fully rendered
        setTimeout(() => {
          const containerWidth = plansContainer.offsetWidth;
          const planWidth = selectedPlan.offsetWidth;
          const planOffset = selectedPlan.offsetLeft;

          // Calculate scroll position to center the selected plan
          const scrollPosition = planOffset - (containerWidth - planWidth) / 2;

          plansContainer.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
          });
        }, 100);
      }

      async addProductsSequentially(variantId, planId, priceLockId, event) {
        // Find the button that was clicked (either continue or checkout)
        const clickedButton = event.target;
        if (!clickedButton) return;

                // Validate required parameters
        if (!variantId) {
          alert('Please select a valid product option.');
          return;
        }

        // Show loading state
        clickedButton.dataset.originalText = clickedButton.textContent;
        clickedButton.textContent = 'Adding to cart...';
        clickedButton.disabled = true;

        try {
          // Step 1: Add main product with selling plan
          const mainProductData = {
            id: parseInt(variantId),
            quantity: 1
          };

          if (planId) {
            mainProductData.selling_plan = parseInt(planId);
          }

          const mainResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(mainProductData)
          });

          if (!mainResponse.ok) {
            const errorData = await mainResponse.json().catch(() => ({}));
            throw new Error(`Failed to add main product: ${mainResponse.status} - ${errorData.description || 'Unknown error'}`);
          }

          // Step 2: Add price lock product (only if price lock is selected and product exists)
          if (this.selectedPriceLock && priceLockId) {
            const priceLockData = {
              id: parseInt(priceLockId),
              quantity: 1
            };

            try {
              const priceLockResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(priceLockData)
              });

              if (!priceLockResponse.ok) {
                const errorData = await priceLockResponse.json().catch(() => ({}));
                throw new Error(`Failed to add price lock product: ${priceLockResponse.status} - ${errorData.description || errorData.message || 'Unknown error'}`);
              }
            } catch (priceLockError) {
              // If price lock fails, still proceed with checkout since main product was added
            }
          }

          // Both products added successfully, redirect to checkout
          window.location.href = '/checkout';

        } catch (error) {
          // Reset button state
          clickedButton.textContent = clickedButton.dataset.originalText || 'Continue';
          clickedButton.disabled = false;

          // Show error message to user
          alert('There was an error adding products to your cart. Please try again.');
        }
      }



      handleContinue(e) {
        e.preventDefault();

        if (!this.selectedDesign) {
          alert('Please select a design first');
          return;
        }

        // Build cart URL and proceed
        this.buildCartUrl(e);
      }


      buildCartUrl(event) {
        if (!this.selectedDesign) {
          return;
        }

        const variantId = this.selectedDesign.getAttribute(`data-variant-${this.selectedQuantity}`);
        const planId = this.selectedDesign.getAttribute(`data-${this.selectedPlan === 'annual' ? 'annual-plan-' : 'month-plan-'}${this.selectedQuantity}`);

        // Get price lock product from the selected plan
        const priceLockProductId = this.selectedPlanElement ? this.selectedPlanElement.getAttribute('data-price-lock') : null;
        const priceLockId = priceLockProductId;

        if (!variantId) {
          return;
        }

        // Store cart info for later use
        const continueBtn = this.root.querySelector('#sbms-continue');
        if (continueBtn) {
          continueBtn.dataset.withPriceLock = this.selectedPriceLock;
          continueBtn.dataset.variantId = variantId;
          continueBtn.dataset.planId = planId;
          continueBtn.dataset.priceLockId = priceLockId;
        }

        // If price lock is selected and we have a price lock product, add products sequentially
        if (this.selectedPriceLock && priceLockId) {
          this.addProductsSequentially(variantId, planId, priceLockId, event);
        } else {
          // No price lock, simple case - just add main product with selling plan
          let url = `/cart/add?id=${variantId}&quantity=1`;
          if (planId) url += `&selling_plan=${planId}`;
          url += `&return_to=/checkout`;

          if (continueBtn) {
            continueBtn.dataset.cartUrl = url;
          }

          // Navigate to checkout
          window.location.href = url;
        }
      }

      handleCheckout(e) {
        e.preventDefault();

        // Use the annual payment plan if selected
        this.selectedPlan = this.selectedPaymentPlan;

        // Build cart URL and proceed
        this.buildCartUrl(e);
      }
    }

    class ProductGallery extends HTMLElement {
      constructor() {
        super();
        this.mainImage = null;
        this.thumbnails = [];
        this.splideInstance = null;
        this.isMobile = window.innerWidth < 768;
      }

      connectedCallback() {
        this.mainImage = this.querySelector('.sbms__gallery-main-image');
        this.thumbnails = [...this.querySelectorAll('[data-thumbnail]')];

        this.setupDesktopGallery();

        // Setup mobile gallery after a short delay to ensure DOM is ready
        if (this.isMobile) {
          requestAnimationFrame(() => {
            this.setupMobileGallery();
          });
        }

        this.handleResize();
      }

      disconnectedCallback() {
        if (this.splideInstance) {
          this.splideInstance.destroy();
        }
      }

      setupDesktopGallery() {
        if (!this.mainImage || this.thumbnails.length === 0) return;

        this.thumbnails.forEach(thumbnail => {
          thumbnail.addEventListener('click', (e) => {
            e.preventDefault();
            this.updateMainImage(thumbnail);
          });
        });
      }

      updateMainImage(thumbnail) {
        const imageSrc = thumbnail.dataset.imageSrc;
        const imageAlt = thumbnail.dataset.imageAlt;

        if (!imageSrc || !this.mainImage) return;

        // Update active state
        this.thumbnails.forEach(t => t.classList.remove('sbms__gallery-thumbnail--active'));
        thumbnail.classList.add('sbms__gallery-thumbnail--active');

        // Update main image
        this.mainImage.src = imageSrc;
        this.mainImage.alt = imageAlt;
      }

      async setupMobileGallery() {
        const splideElement = this.querySelector('.splide');
        if (!splideElement) return;

        // Wait for Splide to load
        await this.waitForSplide();

        if (typeof Splide === 'undefined') {
          return;
        }

        // Initialize Splide
        this.splideInstance = new Splide(splideElement, {
          type: 'loop',
          perPage: 1,
          perMove: 1,
          gap: '1rem',
          pagination: true,
          arrows: false,
          autoplay: false
        });

        this.splideInstance.mount();
      }

      waitForSplide() {
        return new Promise((resolve) => {
          if (typeof Splide !== 'undefined') {
            resolve();
            return;
          }

          let attempts = 0;
          const maxAttempts = 50;

          const checkSplide = setInterval(() => {
            attempts++;

            if (typeof Splide !== 'undefined') {
              clearInterval(checkSplide);
              resolve();
            } else if (attempts >= maxAttempts) {
              clearInterval(checkSplide);
              resolve();
            }
          }, 100);
        });
      }

      handleResize() {
        let resizeTimer;

        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);

          resizeTimer = setTimeout(() => {
            const wasMobile = this.isMobile;
            this.isMobile = window.innerWidth < 768;

            if (wasMobile !== this.isMobile) {
              if (this.isMobile && !this.splideInstance) {
                this.setupMobileGallery();
              } else if (!this.isMobile && this.splideInstance) {
                this.splideInstance.destroy();
                this.splideInstance = null;
              }
            }
          }, 250);
        });
      }
    }

    // Register custom element
    if (!customElements.get('product-gallery')) {
      customElements.define('product-gallery', ProductGallery);
    }

    // Compare Modal Web Component
    class CompareModal extends HTMLElement {
      constructor() {
        super();
        this.overlay = null;
        this.content = null;
        this.closeButton = null;
        this.isOpen = false;
      }

      connectedCallback() {
        this.overlay = this.querySelector('.sbms__compare-modal__overlay');
        this.content = this.querySelector('.sbms__compare-modal__content');
        this.closeButton = this.querySelector('.sbms__compare-modal__close');

        if (!this.overlay || !this.content || !this.closeButton) return;

        this.addEventListeners();
      }

      addEventListeners() {
        // Close on overlay click
        this.overlay.addEventListener('click', () => this.close());

        // Close on close button click
        this.closeButton.addEventListener('click', () => this.close());

        // Close on escape key
        this.handleEscape = (e) => {
          if (e.key === 'Escape' && this.isOpen) {
            this.close();
          }
        };

        // Prevent content clicks from closing
        this.content.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }

      open() {
        this.removeAttribute('hidden');
        this.isOpen = true;
        document.addEventListener('keydown', this.handleEscape);

        // Focus management
        this.previousFocus = document.activeElement;
        this.closeButton.focus();

        // Prevent body scroll
        document.body.style.overflow = 'hidden';
      }

      close() {
        this.setAttribute('hidden', '');
        this.isOpen = false;
        document.removeEventListener('keydown', this.handleEscape);

        // Restore focus
        if (this.previousFocus) {
          this.previousFocus.focus();
        }

        // Restore body scroll
        document.body.style.overflow = '';
      }
    }

    // Price Lock Info Modal Web Component
    class PriceLockInfoModal extends HTMLElement {
      constructor() {
        super();
        this.overlay = null;
        this.content = null;
        this.closeButton = null;
        this.isOpen = false;
      }

      connectedCallback() {
        this.overlay = this.querySelector('.sbms__price-lock-modal__overlay');
        this.content = this.querySelector('.sbms__price-lock-modal__content');
        this.closeButton = this.querySelector('.sbms__price-lock-modal__close');

        if (!this.overlay || !this.content || !this.closeButton) return;

        this.addEventListeners();
      }

      addEventListeners() {
        // Close on overlay click
        this.overlay.addEventListener('click', () => this.close());

        // Close on close button click
        this.closeButton.addEventListener('click', () => this.close());

        // Close on escape key
        this.handleEscape = (e) => {
          if (e.key === 'Escape' && this.isOpen) {
            this.close();
          }
        };

        // Prevent content clicks from closing
        this.content.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }

      open() {
        this.removeAttribute('hidden');
        this.isOpen = true;
        document.addEventListener('keydown', this.handleEscape);

        // Focus management
        this.previousFocus = document.activeElement;
        this.closeButton.focus();

        // Prevent body scroll
        document.body.style.overflow = 'hidden';
      }

      close() {
        this.setAttribute('hidden', '');
        this.isOpen = false;
        document.removeEventListener('keydown', this.handleEscape);

        // Restore focus
        if (this.previousFocus) {
          this.previousFocus.focus();
        }

        // Restore body scroll
        document.body.style.overflow = '';
      }
    }

    // Register modal custom elements
    if (!customElements.get('compare-modal')) {
      customElements.define('compare-modal', CompareModal);
    }

    if (!customElements.get('price-lock-info-modal')) {
      customElements.define('price-lock-info-modal', PriceLockInfoModal);
    }

    // Initialize when DOM is ready
    document.addEventListener('DOMContentLoaded', () => {
      new SilverBarMultiStep();
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silver-bar-no-steps"] && !Shopify.designMode) return;
  try {
    
    const formatPricePerBar = (raw) => raw.replace(/^\(/, '').replace(/\/bar\)$/, '').trim();

    class SilverBarNoSteps {
      constructor() {
        this.root = document.querySelector('.sbns');
        if (!this.root) return;



        this.selectedQuantity = null; // Will be set based on selected plan
        this.selectedDesign = null;
        this.selectedPlan = 'monthly';
        this.selectedPriceLock = false; // No price lock in no-steps version
        this.selectedPlanElement = null; // Store reference to selected plan element

        this.init();
      }

      init() {
        this.bindEvents();
        this.setDefaultSelectedPlan();
        this.preselectFirstDesign();
        this.updatePricePerBar();
        this.applyVariantState();
        this.observeVariantChanges();
        this.updatePricing();
        this.scrollToSelectedPlan();
        this.setupDesignCarousel();
        this.updateDynamicCheckout();
      }

      observeVariantChanges() {
        const observer = new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            if (mutation.attributeName !== 'data-ab-variant') continue;
            this.applyVariantState();
            break;
          }
        });

        observer.observe(this.root, { attributes: true, attributeFilter: ['data-ab-variant'] });
      }

      applyVariantState() {
        const abVariant = this.root.dataset.abVariant;
        if (abVariant !== 'v1' && abVariant !== 'v2') return;

        const checkoutBtn = this.root.querySelector('#sbns-checkout');
        if (!checkoutBtn) return;

        const secureText = checkoutBtn.dataset.secureText || 'Secure My Gold';
        checkoutBtn.textContent = secureText;
        checkoutBtn.dataset.originalText = secureText;
      }

      bindEvents() {

      // Plan selection
          this.root.querySelectorAll('[data-plan]').forEach(plan => {
            plan.addEventListener('click', () => this.selectPlan(plan));
          });

      // Design selection
          this.root.querySelectorAll('[data-design]').forEach(design => {
            design.addEventListener('click', () => this.selectDesign(design));
          });

      // Checkout button
          const checkoutBtn = this.root.querySelector('#sbns-checkout');
          if (checkoutBtn) {
            checkoutBtn.addEventListener('click', (e) => this.handleCheckout(e));
          }

      // Compare button
          const compareButton = this.root.querySelector('.sbns__compare-toggle');
          if (compareButton) {
            compareButton.addEventListener('click', (e) => {
              e.preventDefault();
              const compareModal = document.querySelector('compare-modal');
              if (compareModal && compareModal.open) {
                compareModal.open();
              }
            });
          }

      // Bind "More payment options" click handler for V1/V2 variants
          this.bindMorePaymentOptions();


        }

        selectPlan(plan) {

      // Remove previous selection
          this.root.querySelectorAll('[data-plan]').forEach(p => p.classList.remove('sbns__plan--selected'));

      // Select new plan
          plan.classList.add('sbns__plan--selected');
          this.selectedQuantity = parseInt(plan.dataset.quantity);

      // Store the selected plan for later use
          this.selectedPlanElement = plan;

      // V1: Update per-bar price from block setting (ex-VAT, matches plan card display)
          const abVariant = this.root.dataset.abVariant;

          if (abVariant === 'v1') {
            const perBarPriceElement = this.root.querySelector('[data-per-bar-price]');
            const pricePerBar = plan.dataset.pricePerBar;

            if (perBarPriceElement && pricePerBar) {
              perBarPriceElement.textContent = `${formatPricePerBar(pricePerBar)} per bar / month`;
              perBarPriceElement.style.display = 'block';
            }
          }

      // Update pricing using dynamic variant fetching
          this.updatePricing();

      // Update design images if a design is already selected
          if (this.selectedDesign) {
            this.updateDesignImages(this.selectedDesign);
          }

      // Update dynamic checkout form
          this.updateDynamicCheckout();
        }

        selectDesign(design) {

      // Remove previous selection
          this.root.querySelectorAll('[data-design]').forEach(d => d.classList.remove('sbns__design--selected'));

      // Select new design
          design.classList.add('sbns__design--selected');
          this.selectedDesign = design;

      // Update selection title and description
          const selectionTitle = this.root.querySelector('[data-selection-title]');
          const selectionDescription = this.root.querySelector('[data-selection-description]');

          if (selectionTitle) {
            const designTitle = design.dataset.title || 'Design selected';
            selectionTitle.textContent = designTitle;
          }

          if (selectionDescription) {
            const designDescription = design.dataset.description || '';
            selectionDescription.textContent = designDescription;
          }

      // Update product images to show the selected design's image
          this.updateDesignImages(design);

          this.filterPlansByDesign(design);

      // Update pricing for the selected design
          this.updatePricing();

      // Update price per bar from the selected design's metafield data
          this.updatePricePerBar();

      // Update dynamic checkout form
          this.updateDynamicCheckout();
        }

        updateDynamicCheckout() {
          const variantInput = document.getElementById('sbns-dynamic-checkout-variant');
          const sellingPlanInput = document.getElementById('sbns-dynamic-checkout-selling-plan');
          const productIdInput = document.querySelector('#sbns-dynamic-checkout-form input[name="product-id"]');
          const checkoutContainer = document.querySelector('.sbns__dynamic-checkout');
          const checkoutForm = document.getElementById('sbns-dynamic-checkout-form');
          const acceleratedCheckout = document.querySelector('shopify-accelerated-checkout');
          
          if (!variantInput || !this.selectedDesign || !this.selectedQuantity) {
            if (checkoutContainer) checkoutContainer.style.display = 'none';
            return;
          }

          const variantId = this.selectedDesign.getAttribute(`data-variant-${this.selectedQuantity}`);
          const productId = this.selectedDesign.getAttribute(`data-product-${this.selectedQuantity}`);
          
          // Only show checkout button if selected design has valid variant data
          if (!variantId) {
            if (checkoutContainer) checkoutContainer.style.display = 'none';
            return;
          }
          
          // Valid variant found - show button and update form
          if (checkoutContainer) checkoutContainer.style.display = '';
          
          const previousVariantId = variantInput.value;
          variantInput.value = variantId;
          
          // Update product-id hidden input
          if (productIdInput && productId) {
            productIdInput.value = productId;
          }

          // Update selling plan based on current selection (monthly vs annual)
          if (sellingPlanInput) {
            const planKey = this.selectedPlan === 'annual' ? 'annual-plan-' : 'month-plan-';
            const sellingPlanId = this.selectedDesign.getAttribute(`data-${planKey}${this.selectedQuantity}`);
            sellingPlanInput.value = sellingPlanId || '';
          }
          
          // Update variant-params on the accelerated checkout element
          // This tells Shopify's payment button which variant to use for shipping calculation
          if (acceleratedCheckout && variantId) {
            const newVariantParams = JSON.stringify([{id: parseInt(variantId), requiresShipping: true}]);
            acceleratedCheckout.setAttribute('variant-params', newVariantParams);
          }
          
          // Dispatch variant:change event that Shopify's payment button listens for
          if (previousVariantId !== variantId) {
            const variantChangeEvent = new CustomEvent('variant:change', {
              bubbles: true,
              detail: {
                variant: { id: parseInt(variantId) },
                previousVariant: previousVariantId ? { id: parseInt(previousVariantId) } : null
              }
            });
            document.dispatchEvent(variantChangeEvent);
            
            // Also dispatch on the form element
            if (checkoutForm) {
              checkoutForm.dispatchEvent(variantChangeEvent);
            }
          }

        }

        updateDesignImages(design) {

      // Get the product image based on selected quantity and design
          const productImageSrc = this.getProductImageForDesign(design);
          if (! productImageSrc) return;



      // Update the main gallery image (if using gallery)
          const mainImage = this.root.querySelector('.sbns__gallery-main-image');
          if (mainImage) {
            mainImage.src = productImageSrc;
            mainImage.alt = design.dataset.title || 'Selected design';
          }

      // Update the simple product image (if using fallback image)
          const productImage = this.root.querySelector('.sbns__product-image > img:not(.sbns__gallery-main-image)');
          if (productImage) {
            productImage.src = productImageSrc;
            productImage.alt = design.dataset.title || 'Selected design';
          }
        }
        getProductImageForDesign(design) {

      // Get the bar image from the design
          let barImageSrc = design.dataset.barImage;

          if (! barImageSrc) {
            barImageSrc = design.getAttribute('data-bar-image');
          }

      // Fix the URL if it's missing the protocol
          if (barImageSrc && barImageSrc.startsWith('//')) {
            barImageSrc = 'https:' + barImageSrc;
          }
          return barImageSrc;
        }

        filterPlansByDesign(design) {
          const plansContainer = this.root.querySelector('.sbns__plans');
          if (!plansContainer) return;

          const allPlans = plansContainer.querySelectorAll('[data-plan]');
          let visiblePlansCount = 0;

          allPlans.forEach(plan => {
            const quantity = plan.dataset.quantity;
            const productExists = design.getAttribute(`data-product-exists-${quantity}`);

            if (productExists === 'true') {
              plan.style.display = '';
              plan.classList.remove('sbns__plan--hidden');
              visiblePlansCount++;
            } else {
              plan.style.display = 'none';
              plan.classList.add('sbns__plan--hidden');
              if (plan.classList.contains('sbns__plan--selected')) {
                plan.classList.remove('sbns__plan--selected');
                this.selectedPlanElement = null;
                this.selectedQuantity = null;
              }
            }
          });

          this.updatePlansLayout(visiblePlansCount);
        }

        updatePlansLayout(visiblePlansCount) {
          const plansContainer = this.root.querySelector('.sbns__plans');
          if (!plansContainer) return;

          plansContainer.classList.remove('sbns__plans--1', 'sbns__plans--2', 'sbns__plans--3');

          if (visiblePlansCount === 1) {
            plansContainer.classList.add('sbns__plans--1');
          } else if (visiblePlansCount === 2) {
            plansContainer.classList.add('sbns__plans--2');
          } else if (visiblePlansCount === 3) {
            plansContainer.classList.add('sbns__plans--3');
          }
        }

        preselectFirstDesign() {

      // Find the first design and preselect it (without triggering pricing updates)
          const firstDesign = this.root.querySelector('[data-design]');
          if (firstDesign) { // Remove previous selection
            this.root.querySelectorAll('[data-design]').forEach(d => d.classList.remove('sbns__design--selected'));

      // Select new design
            firstDesign.classList.add('sbns__design--selected');
            this.selectedDesign = firstDesign;

      // Update selection title and description
            const selectionTitle = this.root.querySelector('[data-selection-title]');
            const selectionDescription = this.root.querySelector('[data-selection-description]');

            if (selectionTitle) {
              const designTitle = firstDesign.dataset.title || 'Design selected';
              selectionTitle.textContent = designTitle;
            }

            if (selectionDescription) {
              const designDescription = firstDesign.dataset.description || '';
              selectionDescription.textContent = designDescription;
            }

      // Update product images
            this.updateDesignImages(firstDesign);

            this.filterPlansByDesign(firstDesign);

      // Note: Not calling updatePricing() here to avoid double pricing update during init
          }
        }

        async setupDesignCarousel() {
          const designsCarousel = this.root.querySelector('.sbns__designs.splide');
          if (! designsCarousel) return;



      // Wait for Splide to load
          await this.waitForSplide();

          if (typeof Splide === 'undefined') {
            return;
          }

      // Initialize Splide for designs carousel

          this.designSplideInstance = new Splide(designsCarousel, {
            type: 'slide',
            perPage: 4,
            perMove: 1,
            gap: '0.75rem',
            pagination: false,
            arrows: true,
            autoplay: false,
            drag: 'free',
            snap: false,
            flickPower: 600,
            flickMaxPages: 1,
            speed: 400,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            breakpoints: {
              1240: {
                perPage: 3,
                gap: '0.75rem'
              },
              750: {
                perPage: 3,
                gap: '0.5rem',
                drag: 'free',
                snap: false,
                flickPower: 800,
                flickMaxPages: 1
              }
            }
          });

          this.designSplideInstance.mount();
        }

        waitForSplide() {
          return new Promise((resolve) => {
            if (typeof Splide !== 'undefined') {
              resolve();
              return;
            }

            let attempts = 0;
            const maxAttempts = 50;

            const checkSplide = setInterval(() => {
              attempts++;

              if (typeof Splide !== 'undefined') {
                clearInterval(checkSplide);
                resolve();
              } else if (attempts >= maxAttempts) {
                clearInterval(checkSplide);
                resolve();
              }
            }, 100);
          });
        }

        async updatePricing() {

      // Update pricing display based on selected quantity and design
          const priceDisplays = this.root.querySelectorAll('[data-pricing-display]');
          if (! priceDisplays.length || !this.selectedQuantity) {
            return;
          }

      // Get current design to determine which product to use
          let currentDesign = this.selectedDesign;
          if (! currentDesign) { // If no design selected yet, use the first design
            currentDesign = this.root.querySelector('[data-design]');
          }

          if (! currentDesign) {
            return;
          }

      // Get the variant ID for the selected quantity
          const variantId = currentDesign.getAttribute(`data-variant-${
            this.selectedQuantity
          }`);
          
          if (! variantId) {
            // Enable button by default if no variant found (fallback)
            const checkoutBtn = this.root.querySelector('#sbns-checkout');
            const dynamicCheckout = this.root.querySelector('.sbns__dynamic-checkout');
            if (checkoutBtn) {
              checkoutBtn.disabled = false;
              checkoutBtn.classList.remove('sbns__continue-btn--out-of-stock');
              checkoutBtn.textContent = checkoutBtn.dataset.originalText || 'Add to Cart';
            }
            if (dynamicCheckout) {
              dynamicCheckout.style.display = '';
            }
            return;
          }

          try { // Fetch variant data from Shopify
            const response = await fetch(`/variants/${variantId}.js`);
            if (! response.ok) return;



            const variantData = await response.json();

      // Use original Shopify prices (gross prices including VAT)
            const grossPrice = variantData.price;
            const grossComparePrice = variantData.compare_at_price || null;

      // Use Shopify's money formatting by creating a temporary element
      // This preserves the exact currency formatting from the current market
            const formattedPrice = this.formatPriceUsingShopify(grossPrice);
            const formattedComparePrice = grossComparePrice
              ? this.formatPriceUsingShopify(grossComparePrice)
              : null;

      // Update price elements in all pricing displays
            priceDisplays.forEach(priceDisplay => {

      // Make pricing visible once we have calculated prices
              priceDisplay.style.visibility = 'visible';

              const priceNew = priceDisplay.querySelector('.sbns__price-new');
              const priceOld = priceDisplay.querySelector('.sbns__price-old');
              const priceBadge = priceDisplay.querySelector('.sbns__price-badge');

              if (priceNew) {
                priceNew.textContent = formattedPrice;
                priceNew.style.display = 'inline';
              }

              if (priceOld && formattedComparePrice) {
                priceOld.textContent = formattedComparePrice;
                priceOld.style.display = 'inline';

      // Calculate savings percentage
                const savingsAmount = grossComparePrice - grossPrice;
                const savingsPercentage = Math.round((savingsAmount / grossComparePrice) * 100);

                if (priceBadge && savingsPercentage > 0) {
                  priceBadge.textContent = `Save ${savingsPercentage}%`;
                  priceBadge.style.display = 'inline';
                }
              } else {
                // When there's no compare price, hide the old price and badge
                if (priceOld)
                  priceOld.style.display = 'none';

                if (priceBadge)
                  priceBadge.style.display = 'none';
              }
            });

      // V1: Update per-bar price below main price
            const abVariant = this.root.dataset.abVariant;
            if (abVariant === 'v1' && this.selectedPlanElement) {
              const perBarPriceElement = this.root.querySelector('[data-per-bar-price]');
              const pricePerBar = this.selectedPlanElement.dataset.pricePerBar;
              console.log('[KOIN73] updatePricing per-bar:', pricePerBar, 'element:', perBarPriceElement);

              if (perBarPriceElement && pricePerBar) {
                perBarPriceElement.textContent = `${formatPricePerBar(pricePerBar)} per bar / month`;
                perBarPriceElement.style.display = 'block';
              }
            }

      // Update button state based on stock availability
            const isAvailable = variantData.available !== undefined ? variantData.available : true;
            this.updateButtonAvailability(isAvailable);

          } catch (error) { // Silently handle pricing fetch errors
          }
        }

        updatePricePerBar() {
          if (!this.selectedDesign) return;

          const plans = this.root.querySelectorAll('[data-plan]');
          let maxQuantity = 0;
          let cheapestPricePerBar = null;

          for (const plan of plans) {
            const quantity = parseInt(plan.dataset.quantity, 10);
            const pricePerBar = this.selectedDesign.getAttribute(`data-price-per-bar-${plan.dataset.quantity}`);
            const priceEl = plan.querySelector('.sbns__plan-price');
            if (!priceEl) continue;

            const effectivePrice = pricePerBar || plan.dataset.defaultPricePerBar;

            if (effectivePrice) {
              priceEl.textContent = effectivePrice;
              // Keep data-price-per-bar in sync so selectPlan/updatePricing use the same value
              plan.dataset.pricePerBar = effectivePrice;
            }

            if (quantity > maxQuantity && effectivePrice) {
              maxQuantity = quantity;
              cheapestPricePerBar = effectivePrice;
            }
          }

          // Update the subtitle dynamic price with the cheapest plan's per-bar price
          if (cheapestPricePerBar) {
            const subtitlePriceEl = this.root.querySelector('[data-per-bar-subtitle]');
            if (subtitlePriceEl) {
              subtitlePriceEl.textContent = formatPricePerBar(cheapestPricePerBar);
            }
          }
        }

        updateButtonAvailability(isAvailable) {
          const checkoutBtn = this.root.querySelector('#sbns-checkout');
          const dynamicCheckout = this.root.querySelector('.sbns__dynamic-checkout');
          
          if (!checkoutBtn) return;

          if (isAvailable) {
            checkoutBtn.disabled = false;
            checkoutBtn.classList.remove('sbns__continue-btn--out-of-stock');
            checkoutBtn.textContent = checkoutBtn.dataset.originalText || 'Add to Cart';
            // Show dynamic checkout buttons
            if (dynamicCheckout) {
              dynamicCheckout.style.display = '';
            }
          } else {
            checkoutBtn.disabled = true;
            checkoutBtn.classList.add('sbns__continue-btn--out-of-stock');
            checkoutBtn.textContent = 'Awaiting Stock - Expected Soon';
            // Hide dynamic checkout buttons
            if (dynamicCheckout) {
              dynamicCheckout.style.display = 'none';
            }
          }
        }

        formatPriceUsingShopify(priceInCents) {

      // Use Shopify's theme currency settings for proper localization
          const amount = priceInCents / 100;


      // Try to use Shopify's theme.formatMoney if available
          if (typeof theme !== 'undefined' && theme.formatMoney) {
            return theme.formatMoney(priceInCents);
          }

      // Try to use Shopify's Currency if available
          if (typeof Currency !== 'undefined' && Currency.formatMoney) {
            return Currency.formatMoney(priceInCents);
          }

      // Use browser's Intl.NumberFormat with Shopify's currency from section data
          const currencyCode = this.root.dataset.currentCurrency || document.documentElement.getAttribute('data-currency') || 'GBP'; // fallback

          try {
            const formatter = new Intl.NumberFormat('en', {
              style: 'currency',
              currency: currencyCode,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
              currencyDisplay: 'symbol'
            });
            let formattedPrice = formatter.format(amount);

      // Generic cleanup: remove country prefixes from currency symbols
      // This handles CA$, A$, US$, NZ$, etc. automatically
            formattedPrice = formattedPrice.replace(/^[A-Z]{2}\$/, '$');

            return formattedPrice;
          } catch (error) { // Final fallback: simple format with currency symbol
            const getGenericCurrencySymbol = (code) => {
              const commonSymbols = {
                'GBP': '£',
                'EUR': '€',
                'JPY': '¥',
                'KRW': '₩',
                'INR': '₹'
              };

      // For any currency ending in 'D' (like USD, CAD, AUD, NZD), use $
              if (code.endsWith('D') && code.length === 3) {
                return '$';
              }

              return commonSymbols[code] || code;
            };

            const symbol = getGenericCurrencySymbol(currencyCode);
            return `${symbol}${
              amount.toFixed(2)
            }`;
          }
        }


        updatePricingDisplay(planElement = null) {
          const priceDisplays = this.root.querySelectorAll('[data-pricing-display]');
          if (! priceDisplays.length) return;



      // Use the provided plan element or find the currently selected one
          const selectedPlan = planElement || this.root.querySelector('.sbns__plan--selected');
          if (! selectedPlan) return;



      // Get pricing data from the plan's data attributes
          const price = selectedPlan.getAttribute('data-price');
          const comparePrice = selectedPlan.getAttribute('data-compare-price');

      // Update price elements in all pricing displays
          priceDisplays.forEach(priceDisplay => {

      // Make pricing visible once we have calculated prices
            priceDisplay.style.visibility = 'visible';

            const priceNew = priceDisplay.querySelector('.sbns__price-new');
            const priceOld = priceDisplay.querySelector('.sbns__price-old');
            const priceBadge = priceDisplay.querySelector('.sbns__price-badge');

            if (priceNew && price) {
              priceNew.textContent = price;
              priceNew.style.display = 'inline-block';
            }

      // Show/hide old price (compare_at_price)
            if (priceOld) {
              if (comparePrice && comparePrice !== price) {
                priceOld.textContent = comparePrice;
                priceOld.style.display = 'inline-block';
              } else {
                priceOld.style.display = 'none';
              }
            }

      // Calculate and show savings badge
            if (priceBadge) {
              if (comparePrice && price && comparePrice.trim() !== '' && price.trim() !== '') { // Extract numeric values for calculation
                const priceNumeric = parseFloat(price.replace(/[^\d.]/g, ''));
                const comparePriceNumeric = parseFloat(comparePrice.replace(/[^\d.]/g, ''));

      // Check if we have valid numbers and compare price is higher
                if (!isNaN(priceNumeric) && !isNaN(comparePriceNumeric) && comparePriceNumeric > priceNumeric && comparePriceNumeric > 0) {
                  const savings = Math.round(((comparePriceNumeric - priceNumeric) / comparePriceNumeric) * 100);
                  if (savings > 0) {
                    priceBadge.textContent = `Save ${savings}%`;
                    priceBadge.style.display = 'inline-block';
                  } else {
                    priceBadge.style.display = 'none';
                  }
                } else {
                  priceBadge.style.display = 'none';
                }
              } else { // Hide badge if no valid pricing data
                priceBadge.style.display = 'none';
              }
            }
          });

      // V1: Update per-bar price from selected plan on initial load and design changes
          const abVariant = this.root.dataset.abVariant;

          if (abVariant === 'v1') {
            const perBarPriceElement = this.root.querySelector('[data-per-bar-price]');
            const pricePerBar = selectedPlan.dataset.pricePerBar;

            if (perBarPriceElement && pricePerBar) {
              perBarPriceElement.textContent = `${formatPricePerBar(pricePerBar)} per bar / month`;
              perBarPriceElement.style.display = 'block';
            }
          }
        }


        setDefaultSelectedPlan() {

      // Find the default selected plan (either popular pick or first plan)
          const selectedPlan = this.root.querySelector('.sbns__plan--selected');
          if (selectedPlan) {
            this.selectedPlanElement = selectedPlan;

      // Set the selected quantity from the selected plan
            this.selectedQuantity = parseInt(selectedPlan.dataset.quantity);
          }
        }

        scrollToSelectedPlan() {

      // Only scroll on mobile
          if (window.innerWidth > 768) return;



          const plansContainer = this.root.querySelector('.sbns__plans');
          const selectedPlan = this.root.querySelector('.sbns__plan--selected');

          if (! plansContainer || ! selectedPlan) return;



      // Use setTimeout to ensure DOM is fully rendered
          setTimeout(() => {
            const containerWidth = plansContainer.offsetWidth;
            const planWidth = selectedPlan.offsetWidth;
            const planOffset = selectedPlan.offsetLeft;

      // Calculate scroll position to center the selected plan
            const scrollPosition = planOffset - (containerWidth - planWidth) / 2;

            plansContainer.scrollTo({left: scrollPosition, behavior: 'smooth'});
          }, 100);
        }

        bindMorePaymentOptions() {
          const abVariant = this.root.dataset.abVariant;
          if (abVariant !== 'v1' && abVariant !== 'v2') return;

          const proxy = this.root.querySelector('[data-more-options-proxy]');
          if (!proxy) return;

          proxy.addEventListener('click', async (e) => {
            e.preventDefault();

            const variantId = document.getElementById('sbns-dynamic-checkout-variant')?.value;
            const sellingPlan = document.getElementById('sbns-dynamic-checkout-selling-plan')?.value;
            if (!variantId) return;

            try {
              const body = {
                items: [{
                  id: parseInt(variantId),
                  quantity: 1,
                }]
              };

              if (sellingPlan) body.items[0].selling_plan = parseInt(sellingPlan);

              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
              });

              window.location.href = '/checkout';
            } catch (err) {
              console.error('[SBNS] More payment options error:', err);
            }
          });
        }

        async addProductsSequentially(variantId, planId, priceLockId, event) {

      // Find the button that was clicked (either continue or checkout)
          const clickedButton = event.target;
          if (! clickedButton) return;



      // Validate required parameters
          if (!variantId) {
            alert('Please select a valid product option.');
            return;
          }

      // Show loading state
          clickedButton.dataset.originalText = clickedButton.textContent;
          clickedButton.textContent = 'Adding to cart...';
          clickedButton.disabled = true;

          try { // Step 1: Add main product with selling plan
            const mainProductData = {
              id: parseInt(variantId),
              quantity: 1
            };

            if (planId) {
              mainProductData.selling_plan = parseInt(planId);
            }

            const mainResponse = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(mainProductData)
            });

            if (! mainResponse.ok) {
              const errorData = await mainResponse.json().catch(() => ({}));
              throw new Error(`Failed to add main product: ${
                mainResponse.status
              } - ${
                errorData.description || 'Unknown error'
              }`);
            }

      // Step 2: Add price lock product (only if price lock is selected and product exists)
            if (this.selectedPriceLock && priceLockId) {
              const priceLockData = {
                id: parseInt(priceLockId),
                quantity: 1
              };

              try {
                const priceLockResponse = await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(priceLockData)
                });

                if (! priceLockResponse.ok) {
                  const errorData = await priceLockResponse.json().catch(() => ({}));
                  throw new Error(`Failed to add price lock product: ${
                    priceLockResponse.status
                  } - ${
                    errorData.description || errorData.message || 'Unknown error'
                  }`);
                }
              } catch (priceLockError) { // If price lock fails, still proceed with checkout since main product was added
              }
            }

      // Both products added successfully, check for cross-sell redirect
            const crossSellUrl = this.root.dataset.crossSellUrl;
            const crossSellEnabled = this.root.dataset.crossSellEnabled === 'true';
            const crossSellActive = document.body.dataset.crossSell === 'active' || crossSellEnabled;
            const designTitle = this.selectedDesign?.dataset.title;

            if (crossSellActive && crossSellUrl && designTitle) {
              // Redirect to cross-sell page with design parameter
              const url = new URL(crossSellUrl, window.location.origin);
              url.searchParams.set('design', designTitle);
              window.location.href = url.toString();
            } else {
              window.location.href = '/checkout';
            }

          } catch (error) { // Reset button state
            clickedButton.textContent = clickedButton.dataset.originalText || 'Continue';
            clickedButton.disabled = false;

      // Show error message to user
            alert('There was an error adding products to your cart. Please try again.');
          }
        }


        buildCartUrl(event) {
          if (!this.selectedDesign) {
            return;
          }

          const variantId = this.selectedDesign.getAttribute(`data-variant-${
            this.selectedQuantity
          }`);
          const planId = this.selectedDesign.getAttribute(`data-${
            this.selectedPlan === 'annual'
              ? 'annual-plan-'
              : 'month-plan-'
            }${
            this.selectedQuantity
          }`);

      // Get price lock product from the selected plan
          const priceLockProductId = this.selectedPlanElement
            ? this.selectedPlanElement.getAttribute('data-price-lock')
            : null;
          const priceLockId = priceLockProductId;

          if (! variantId) {
            return;
          }

      // If price lock is selected and we have a price lock product, add products sequentially
          if (this.selectedPriceLock && priceLockId) {
            this.addProductsSequentially(variantId, planId, priceLockId, event);
          } else { // No price lock, simple case - just add main product with selling plan
            let url = `/cart/add?id=${variantId}&quantity=1`;
            if (planId)
              url += `&selling_plan=${planId}`;

            // Check for cross-sell redirect
            const crossSellUrl = this.root.dataset.crossSellUrl;
            const crossSellActive = document.body.dataset.crossSell === 'active';
            const designTitle = this.selectedDesign?.dataset.title;

            if (crossSellActive && crossSellUrl && designTitle) {
              // Add product to cart with return to cross-sell page
              url += `&return_to=${encodeURIComponent(crossSellUrl + '?design=' + encodeURIComponent(designTitle))}`;
            } else {
              url += `&return_to=/checkout`;
            }

      // Navigate to add to cart
            window.location.href = url;
          }
        }

        handleCheckout(e) {
          e.preventDefault();

          const checkoutBtn = this.root.querySelector('#sbns-checkout');
          if (checkoutBtn && checkoutBtn.disabled) {
            return;
          }

          if (!this.selectedDesign) {
            alert('Please select a design first');
            return;
          }

      // Build cart URL and proceed
          this.buildCartUrl(e);
        }
      }

      class ProductGallery extends HTMLElement {
        constructor() {
          super();
          this.mainImage = null;
          this.thumbnails = [];
          this.splideInstance = null;
          this.isMobile = window.innerWidth < 768;
        }

        connectedCallback() {
          this.mainImage = this.querySelector('.sbns__gallery-main-image');
          this.thumbnails = [...this.querySelectorAll('[data-thumbnail]')];

          this.setupDesktopGallery();

      // Setup mobile gallery after a short delay to ensure DOM is ready
          if (this.isMobile) {
            requestAnimationFrame(() => {
              this.setupMobileGallery();
            });
          }

          this.handleResize();
        }

        disconnectedCallback() {
          if (this.splideInstance) {
            this.splideInstance.destroy();
          }
        }

        setupDesktopGallery() {
          if (!this.mainImage || this.thumbnails.length === 0) return;



          this.thumbnails.forEach(thumbnail => {
            thumbnail.addEventListener('click', (e) => {
              e.preventDefault();
              this.updateMainImage(thumbnail);
            });
          });
        }

        updateMainImage(thumbnail) {
          const imageSrc = thumbnail.dataset.imageSrc;
          const imageAlt = thumbnail.dataset.imageAlt;

          if (! imageSrc || !this.mainImage) return;



      // Update active state
          this.thumbnails.forEach(t => t.classList.remove('sbns__gallery-thumbnail--active'));
          thumbnail.classList.add('sbns__gallery-thumbnail--active');

      // Update main image
          this.mainImage.src = imageSrc;
          this.mainImage.alt = imageAlt;
        }

        async setupMobileGallery() {
          const splideElement = this.querySelector('.splide');
          if (! splideElement) return;



      // Wait for Splide to load
          await this.waitForSplide();

          if (typeof Splide === 'undefined') {
            return;
          }

      // Initialize Splide
          this.splideInstance = new Splide(splideElement, {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            gap: '1rem',
            pagination: true,
            arrows: false,
            autoplay: false
          });

          this.splideInstance.mount();
        }

        waitForSplide() {
          return new Promise((resolve) => {
            if (typeof Splide !== 'undefined') {
              resolve();
              return;
            }

            let attempts = 0;
            const maxAttempts = 50;

            const checkSplide = setInterval(() => {
              attempts++;

              if (typeof Splide !== 'undefined') {
                clearInterval(checkSplide);
                resolve();
              } else if (attempts >= maxAttempts) {
                clearInterval(checkSplide);
                resolve();
              }
            }, 100);
          });
        }

        handleResize() {
          let resizeTimer;

          window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(() => {
              const wasMobile = this.isMobile;
              this.isMobile = window.innerWidth < 768;

              if (wasMobile !== this.isMobile) {
                if (this.isMobile && !this.splideInstance) {
                  this.setupMobileGallery();
                } else if (!this.isMobile && this.splideInstance) {
                  this.splideInstance.destroy();
                  this.splideInstance = null;
                }
              }
            }, 250);
          });
        }
      }

      // Register custom element
      if (!customElements.get('product-gallery')) {
        customElements.define('product-gallery', ProductGallery);
      }

      // Compare Modal Web Component
      class CompareModal extends HTMLElement {
        constructor() {
          super();
          this.overlay = null;
          this.content = null;
          this.closeButton = null;
          this.isOpen = false;
        }

        connectedCallback() {
          this.overlay = this.querySelector('.sbns__compare-modal__overlay');
          this.content = this.querySelector('.sbns__compare-modal__content');
          this.closeButton = this.querySelector('.sbns__compare-modal__close');

          if (!this.overlay || !this.content || !this.closeButton) return;



          this.addEventListeners();
        }

        addEventListeners() {

      // Close on overlay click
          this.overlay.addEventListener('click', () => this.close());

      // Close on close button click
          this.closeButton.addEventListener('click', () => this.close());

      // Close on escape key
          this.handleEscape = (e) => {
            if (e.key === 'Escape' && this.isOpen) {
              this.close();
            }
          };

      // Prevent content clicks from closing
          this.content.addEventListener('click', (e) => {
            e.stopPropagation();
          });
        }

        open() {
          this.removeAttribute('hidden');
          this.isOpen = true;
          document.addEventListener('keydown', this.handleEscape);

      // Focus management
          this.previousFocus = document.activeElement;
          this.closeButton.focus();

      // Prevent body scroll
          document.body.style.overflow = 'hidden';
        }

        close() {
          this.setAttribute('hidden', '');
          this.isOpen = false;
          document.removeEventListener('keydown', this.handleEscape);

      // Restore focus
          if (this.previousFocus) {
            this.previousFocus.focus();
          }

      // Restore body scroll
          document.body.style.overflow = '';
        }
      }

      // Price Lock Info Modal Web Component
      class PriceLockInfoModal extends HTMLElement {
        constructor() {
          super();
          this.overlay = null;
          this.content = null;
          this.closeButton = null;
          this.isOpen = false;
        }

        connectedCallback() {
          this.overlay = this.querySelector('.sbns__price-lock-modal__overlay');
          this.content = this.querySelector('.sbns__price-lock-modal__content');
          this.closeButton = this.querySelector('.sbns__price-lock-modal__close');

          if (!this.overlay || !this.content || !this.closeButton) return;



          this.addEventListeners();
        }

        addEventListeners() {

      // Close on overlay click
          this.overlay.addEventListener('click', () => this.close());

      // Close on close button click
          this.closeButton.addEventListener('click', () => this.close());

      // Close on escape key
          this.handleEscape = (e) => {
            if (e.key === 'Escape' && this.isOpen) {
              this.close();
            }
          };

      // Prevent content clicks from closing
          this.content.addEventListener('click', (e) => {
            e.stopPropagation();
          });
        }

        open() {
          this.removeAttribute('hidden');
          this.isOpen = true;
          document.addEventListener('keydown', this.handleEscape);

      // Focus management
          this.previousFocus = document.activeElement;
          this.closeButton.focus();

      // Prevent body scroll
          document.body.style.overflow = 'hidden';
        }

        close() {
          this.setAttribute('hidden', '');
          this.isOpen = false;
          document.removeEventListener('keydown', this.handleEscape);

      // Restore focus
          if (this.previousFocus) {
            this.previousFocus.focus();
          }

      // Restore body scroll
          document.body.style.overflow = '';
        }
      }

      // Register modal custom elements
      if (!customElements.get('compare-modal')) {
        customElements.define('compare-modal', CompareModal);
      }

      if (!customElements.get('price-lock-info-modal')) {
        customElements.define('price-lock-info-modal', PriceLockInfoModal);
      }

      // Initialize when DOM is ready
      document.addEventListener('DOMContentLoaded', () => {
        const section = document.querySelector('.sbns');
        if (section) {
          const marketHandle = section.dataset.currentMarket;
          const countryCode = section.dataset.currentCountry?.toLowerCase();
          const marketKey = marketHandle.split('-')[0];
          console.log('[KOIN72] Country code:', countryCode, '| Market handle:', marketHandle, '→ fallback key:', marketKey);
        }

        new SilverBarNoSteps();
      });
  
  } catch(e) { console.error(e); }
})();
})();
